import { OnboardingExperimentVariant } from './experiment.const'
import { OnboardingFlowStep } from './types'

export const ORDERED_STEPS: OnboardingFlowStep[] = [
  OnboardingFlowStep.HOW_MANY_LEARNERS,
  OnboardingFlowStep.WORKING_ON,
  OnboardingFlowStep.WHAT_MATTERS,
  OnboardingFlowStep.MATH_FEELING,
  OnboardingFlowStep.SETUP_READY,
  OnboardingFlowStep.CREATE_ACCOUNT,
  OnboardingFlowStep.FREE_TRIAL,
  OnboardingFlowStep.YOUR_PLAN,
]

export const PER_LEARNER_STEPS: OnboardingFlowStep[] = [
  OnboardingFlowStep.WORKING_ON,
  OnboardingFlowStep.WHAT_MATTERS,
  OnboardingFlowStep.MATH_FEELING,
]

// 220926-{no,us}-onboarding-slide5. The arms differ by which steps exist, not by skip rules at the
// call sites: everything downstream — next, previous, progress, the analytics step number — reads
// one list, so an arm cannot advance past a step it still walks back onto.
const VARIANT_ORDERED_STEPS: OnboardingFlowStep[] = ORDERED_STEPS.filter(
  (step) => step !== OnboardingFlowStep.SETUP_READY,
)

// Only 'variant' is the variant. PostHog serves anything else — 'control', or nothing at all for a
// country outside the test — and all of it means the full funnel, same rule middleware applies.
export function getOrderedSteps(arm?: OnboardingExperimentVariant): OnboardingFlowStep[] {
  return arm === 'variant' ? VARIANT_ORDERED_STEPS : ORDERED_STEPS
}
